module.exports = __webpack_public_path__ + "static/img/xyt-logo.8c84e7ce.png";